<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M10.0002 2.29199L9.99996 5.20866M10.0002 14.792V17.7087M2.29163 10.0009H5.20829M14.7916 10.0009H17.7083M4.54952 4.54953L6.61174 6.61211M13.3884 13.3884L15.4508 15.4508M4.54976 15.4514L6.61215 13.389M13.3886 6.61252L15.451 4.55012" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'NewLaunchedIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>